import { contentApi } from '@/infrastructure/Configuration'

export default class NearbyHotelsService {
  constructor (httpClient) {
    this.httpClient = httpClient
  }

  async findByHotel (hotelCode) {
    const url = `${contentApi}/hotels/${hotelCode}/nearby-hotels`

    const response = await this.httpClient.get(url)

    return response.data
  }
}
